import { Link } from 'react-router-dom';
import ProductActionButton from './ProductActionButton';
import './ProductCard.css';

const ProductCardHorizontal = ({ product }) => {

  return (
  <div className="product-card" id={"goodsView"+product.goods_seq}>
    <Link className="product-detail" to={`/store/goods/${product.goods_seq}`}>
      <div className="product-thumb">
        <img src={"https://cdn.cokeplay.cocacola.co.kr" + product.list1_image_url} alt="" className="pch-image" loading="lazy"/>
      </div>
      <div className="product-info">
        <div className="product-name">{product.display_goods_name}</div>
        <div className="product-price">
            <div className="current-price">
                {product.discount_price && (
                <span className="discount-percent">{Math.round(((product.price - product.discount_price) / product.price) * 100)}%</span>)}
                <span className="price-amount">{product.discount_price ? product.discount_price.toLocaleString() : product.price.toLocaleString()}</span>
                <span>원</span>
            </div>
            <div className="original-price">
                {product.discount_price && (<span>{product.price.toLocaleString()}원</span>)}
            </div>
        </div>
      </div>
    </Link>
    <ProductActionButton goods_seq={product.goods_seq} />
  </div>)
};

export default ProductCardHorizontal; 


